import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { Document, Page, pdfjs } from 'react-pdf';
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "./_instRevisionMaterial.scss";

// react-pdf needs pdf.js's worker configured explicitly (it isn't auto-wired). Served
// from this app's own public/ folder (copied from node_modules/pdfjs-dist/build, must
// stay in sync with the installed pdfjs-dist version) rather than a CDN — browsers
// restrict constructing a Worker from a cross-origin script, and pdf.js 2.x's fallback
// for that case is unreliable, so a same-origin worker avoids the failure mode entirely.
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;

const FIN = {
    header: { border: "none", padding: "18px 24px", background: "linear-gradient(135deg, rgb(99, 102, 241), rgb(139, 92, 246))" },
    headerTitle: { fontSize: 16, fontWeight: 800, color: "#fff", display: "flex", alignItems: "center", gap: 8, margin: 0 },
    headerSubtitle: { fontSize: 12, color: "rgba(255,255,255,0.85)", marginTop: 4 },
    body: { background: "#f8fafc", padding: 20 },
    pdfWrap: { background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, minHeight: 420, maxHeight: "70vh", overflow: "auto", padding: 16, display: "flex", flexDirection: "column", alignItems: "center" },
    statusWrap: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: 320, color: "#6b7280", gap: 10, fontSize: 13 },
};

class MaterialPDFViewModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            numPages: null,
            loadError: false,
        };
    }

    componentDidUpdate(prevProps) {
        // Reset load state each time a different material is opened, since this modal
        // stays mounted and just toggles `show`.
        if (this.props.show && !prevProps.show) {
            this.setState({ numPages: null, loadError: false });
        }
    }

    render() {
        const material = this.props.stateData?.individualMaterials?.[0];
        // file_path is normally an absolute URL (the file-upload API always returns one),
        // but a handful of older records were saved as a bare "getFileData?uuid=..." path
        // with no domain — that resolves against this app's own origin instead of the
        // file server and 404s. Recover it the same way the upload API constructs it.
        const rawPath = material?.file_path;
        const filePath = rawPath && !/^https?:\/\//i.test(rawPath)
            ? `https://capi.rizee.in/${rawPath.replace(/^\/+/, "")}`
            : rawPath;
        const subtitle = [material?.class_name, material?.subject_name, material?.chapter_name].filter(Boolean).join(" · ");

        return (
            <Modal {...this.props} size="lg" aria-labelledby="material-pdf-view-modal" centered className="revision-material-modal">
                <Modal.Header closeButton style={FIN.header}>
                    <div>
                        <Modal.Title style={FIN.headerTitle}>
                            <i className="fal fa-file-pdf" />
                            {material?.file_name || "View Material"}
                        </Modal.Title>
                        {subtitle ? <div style={FIN.headerSubtitle}>{subtitle}</div> : null}
                    </div>
                </Modal.Header>
                <Modal.Body style={FIN.body}>
                    <div style={FIN.pdfWrap}>
                        {!filePath ? (
                            <div style={FIN.statusWrap}>
                                <i className="fal fa-file-exclamation" style={{ fontSize: 30 }} />
                                <span>No file available for this material.</span>
                            </div>
                        ) : this.state.loadError ? (
                            <div style={FIN.statusWrap}>
                                <i className="fal fa-exclamation-triangle" style={{ fontSize: 30, color: "#dc2626" }} />
                                <span>Couldn&apos;t load this PDF.</span>
                                <a href={filePath} target="_blank" rel="noopener noreferrer" style={{ color: "#6366f1", fontWeight: 600 }}>Open in a new tab</a>
                            </div>
                        ) : (
                            <Document
                                file={filePath}
                                onLoadSuccess={({ numPages }) => this.setState({ numPages, loadError: false })}
                                onLoadError={() => this.setState({ loadError: true })}
                                // onSourceError (a bad/unreachable `file` value, as opposed to a
                                // parse failure once fetched) doesn't set react-pdf's internal
                                // error state on its own — without this it gets stuck showing
                                // `loading` forever instead of surfacing a failure.
                                onSourceError={() => this.setState({ loadError: true })}
                                error={
                                    <div style={FIN.statusWrap}>
                                        <i className="fal fa-exclamation-triangle" style={{ fontSize: 30, color: "#dc2626" }} />
                                        <span>Couldn&apos;t load this PDF.</span>
                                    </div>
                                }
                                loading={
                                    <div style={FIN.statusWrap}>
                                        <span className="spinner-border spinner-border-sm" style={{ color: "#6366f1" }} />
                                        <span>Loading PDF…</span>
                                    </div>
                                }
                            >
                                {Array.from(new Array(this.state.numPages || 0), (el, index) => (
                                    <Page key={`page_${index + 1}`} pageNumber={index + 1} width={670} className="mb-3" />
                                ))}
                            </Document>
                        )}
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}
export default MaterialPDFViewModal;
